// extracted by mini-css-extract-plugin
export default {"warningIcon":"styles-module__warningIcon___Q5un4","footer":"styles-module__footer____HwqI"};